import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { colors, font, shadow, spacing } from '@mobi/component-library/Foundations'
import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'

const enum LocalConstants {
  FeedSortButtonBarClass = 'js-feed-page-sort-button_class',
}

export const SortButtonBar: React.FC<
  ({ label: string; onClick(): void } | { label?: never; onClick?: never }) & {
    isOnSearchPage?: boolean
  }
> = ({ onClick, label, isOnSearchPage }) => {
  const handleSearchProfilesClick = () => {
    appHistory.push(AppRoutes.BetLoopSearchProfiles)
  }
  return (
    <SortFeedButtonWrapperStyled
      className={isOnSearchPage ? '' : LocalConstants.FeedSortButtonBarClass}
    >
      {onClick ? (
        <Button color='tertiary_color' size='xs' onClick={onClick}>
          Sort By:
          <strong>{label}</strong>
          <Icon name='SolidChevronDown' size='1.4rem' />
        </Button>
      ) : (
        <span />
      )}

      {!isOnSearchPage && (
        <Button
          isIconOnlyButton
          color='tertiary_color'
          data-testid='BetLoop.Search'
          onClick={handleSearchProfilesClick}
        >
          <Icon name='LineUsersPlus' size='2.4rem' />
        </Button>
      )}
    </SortFeedButtonWrapperStyled>
  )
}

// ======
// Styles
// ======

const SortFeedButtonWrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: spacing.smx2,
  alignSelf: 'stretch',
  padding: `0 ${spacing.smx2} ${spacing.smx2} ${spacing.smx2}`,

  [`&.${LocalConstants.FeedSortButtonBarClass}`]: {
    alignItems: 'center',
    padding: '0 0.2rem',
    color: colors.lavender['700'],
    backgroundColor: colors.white,
    position: 'relative',
    zIndex: 1,
    justifyContent: 'space-between',
    height: '5.2rem',
    borderBottom: `1px solid ${colors.neutral[100]}`,
    boxShadow: shadow.xs,
  },

  '> button:first-of-type': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${spacing.smx1} ${spacing.sm}`,
    height: '3.2rem',
    gap: spacing.smx2,

    strong: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: font.weight.semibold,
    },
  },
})
